<template>
  <!--visitSource = 2  PC端 -->
  <div :style="pageSetInfo.listStyleSet.pageFieldRotationBoxStyleSet?pageSetInfo.listStyleSet.pageFieldRotationBoxStyleSet.styleSetCode:''" kwName="pageFieldRotationBoxStyleSet">
    <el-carousel class="swiper-container" indicator-dots :autoplay="pageSetInfo.listStyleSet.carouselAutoPlay!=2?true:false" arrow="always" trigger="click" :type="pageSetInfo.listStyleSet.carouselType?pageSetInfo.listStyleSet.carouselType:''" :height="(pageSetInfo.listStyleSet.pageFieldRotationCommonStyleSet && pageSetInfo.listStyleSet.pageFieldRotationCommonStyleSet.height)?pageSetInfo.listStyleSet.pageFieldRotationCommonStyleSet.height:'150px'" previous-margin="10px" next-margin="10px" circular="ture" @change="carouselChange">
      <el-carousel-item v-for="(dataInfo,index) in dataList" :key="index"  class="swiper-slide" style="display: flex;justify-content: center">
        <img class="swiper_imge" :src="GLOBAL.getFileServeUrl()+dataInfo.BG_FILE" @click="listDataClick(dataInfo,index)" :style="pageSetInfo.listStyleSet.pageFieldRotationCommonStyleSet?pageSetInfo.listStyleSet.pageFieldRotationCommonStyleSet.styleSetCode:''" kwName="pageFieldRotationCommonStyleSet" />
        <template v-for="(fieldInfo,fieldIndex) in listFieldSet"  >
          <template v-if="(fieldInfo.fieldAliasName != 'BG_FILE' && fieldInfo.styleSet.isHavingField != 1)">
            <kw_card_field :key="'listField_'+fieldIndex" :fieldInfo="fieldInfo" :fieldIndex="fieldIndex" :dataInfo="dataInfo" :pageSetInfo="pageSetInfo" :isHaving="0"></kw_card_field>
          </template>
        </template>
      </el-carousel-item>
    </el-carousel>
    <kw_look v-if="detailPageInfo.ifLoaded" :pageInfo="detailPageInfo"  :isLimitButton="isLimitButton"  @getParentKwLook="getParentKwLook" @getParentKwList="getParentKwList"></kw_look>
  </div>
</template>

<script>
//card字段组件 kw_card_field
import kw_card_field from '@/components/list/kw_card_field.vue';
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';

export default {
  name: 'kw_list_carousel',
  props: {
    pageSetInfo: {
      type: Object,
      value: null
    },
    listFieldSet: {
      type: Array,
      value: null
    },
    //列表数据全部显示
    dataList: {
      type: Array,
      value: null
    },
    //单一一条数据进行显示
    dataInfo: {
      type: Object,
      value: null
    },
    initDataIndex: {
      type: Number,
      value: 0
    },
    previewVisitSource:{
      type:Number,
      default:0
    },
    //按钮是否根据角色权限限制
    isLimitButton:{
      type: Boolean,
      default: false
    }
  },
  data() {
    var that = this;
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(that),
      oneIndex:null,
      detailPageInfo:{},
    };
  },
  created() {
    this.updataDataList();
  },
  mounted() {
    
  },
  watch:{
    dataList:function(newVal){
      this.updataDataList();
    }
  },
  computed:{
  },
  components: {
    kw_card_field,
    kw_look:resolve => require(['@/components/look/kw_look.vue'], resolve),
  },
  methods: {
    //数据加载时初始进行处理
    updataDataList() {
      if(this.dataList.length > 0) {
        if ((this.pageSetInfo.listStyleSet.clickType == 2 && this.dataList.length > 0)||(this.pageSetInfo.operaButtonSet && this.pageSetInfo.operaButtonSet.length > 0 && this.pageSetInfo.operaButtonSet[0].styleSet.openWay == 6)) {
          this.oneIndex = 0;
          pageUtils.listDataClick(this, this.dataList[0]);
        }
      }
    },
    //轮播图切换方法
    carouselChange(index) {
      console.log("index================",index);
      if (this.pageSetInfo.listStyleSet.carouselChangeClick == 1) {
        pageUtils.listDataClick(this, this.dataList[index]);
      }
    },
    /**
     * 列表数据点击时 进行跳转
     */
    listDataClick(dataInfo,index) {
      this.oneIndex = index;
      pageUtils.listDataClick(this, dataInfo);
    },
    /**
     * 列表按钮点击事件
     */
    dataButtonClick: function (detail,dataInfo) {
      pageUtils.dataButtonClick(this,detail,dataInfo);
    },
    /**
     * 获取最外层的的kw_look组件
     */
    getParentKwLook(callback) {
      console.log("kw_card_default========getParentKwLook========");
      if(this.$listeners['getParentKwLook']){
        var parentKwLook;
        this.$emit("getParentKwLook",val => {
            parentKwLook = val
        });
        callback(parentKwLook);
      } else {
        callback(null);
      }
    },
    getParentKwList(callback) {
      callback(this);
    },
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.swiper-container .swiper-wrapper .swiper-slide{border-radius: 10px;}
.swiper_imge {width: 340px;height:100%;border-radius: 10px;}
.swiper-container .swiper-slide::before{
    border:5px solid #ff6682;  
}
.swiper-container{background: transparent}
</style>
